export default {
  List: {
    Title: "Bảo dưỡng/Sửa chữa",
    Search: "Tìm kiếm",
    AssetRepair: "Tài sản cần sữa chữa (4)",
    AssetMaintenance: "Tài sản cần bảo dưỡng (4)",
    DateRepairMaintenance: "Lịch sửa chữa bảo dưỡng (3)",
  },
};
